// Service
import licenseService from "services/Auth.License.service";
import orgService from "services/Auth.Organization.service";
import Nuclias from "const/nuclias";
import { deviceTypeMapping } from "./const";

const { licenseConfig } = Nuclias;

const getLicenseApi = async (params) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const data = await licenseService.getLicense(params);
      Resolve(data);
    } catch (error) {
      Reject(error);
    }
  });
};
const getOrgBootstrapApi = (orgId) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const res = await orgService.getOrgBootstrap(orgId);
      Resolve(res.data);
    } catch (error) {
      console.error(`getOrgBootstrapApi: ${error}`);
      Reject();
    }
  });
};

const getProfileList = (
  selectedDeviceGroups,
  selectedSiteId,
  assignToDevice
) => {
  return selectedDeviceGroups
    .filter((item) => {
      if (
        item.deviceModel &&
        item.deviceModel?.deviceType === assignToDevice.type &&
        item.deviceModel?.name === assignToDevice.modelName
      ) {
        if (!item.storeId) {
          return true;
        }
        if (item.storeId.toString() === selectedSiteId.toString()) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    })
    .map((item) => {
      return { title: item.name, id: item.id };
    })
    .sort((a, b) => a.title.localeCompare(b.title));
};

const getRemaining = (licenses) => {
  // let remaining = { ap: 0, gateway: 0, switch: 0 };
  // licenseConfig.state.AVAILABLE
  let isLicenseUnusedInactive = false;
  let isLicenseUnitYear = false;
  let isLicensePeriodThan7 = false;
  // isLicenseUnusedInactive = !licensesItem['startDate'] and licensesItem['state'] is BasicFactory.pageContext.license.spec.state.AVAILABLE
  // isLicenseUnitYear = licensesItem['unit'] is 'YEAR'
  // isLicensePeriodThan7 = licensesItem['period'] > 7

  // if !isLicenseUnitYear or isLicensePeriodThan7 or !isLicenseUnusedInactive then return
  return licenses.filter((license) => {
    isLicenseUnusedInactive =
      !license["startDate"] &&
      license["state"] === licenseConfig.state.AVAILABLE;
    isLicenseUnitYear = license["unit"] === "YEAR";
    isLicensePeriodThan7 = license["period"] > 7 ? true : false;
    if (!isLicenseUnitYear || isLicensePeriodThan7 || !isLicenseUnusedInactive)
      return false;
    return true;
  });
  // dayjs(lic[item]).unix()
  // return remaining;
};

export default {
  getLicenseApi,
  getOrgBootstrapApi,
  getProfileList,
  getRemaining,
};
